import { Controller } from "@hotwired/stimulus"
import { fetchWithCsrf, getCsrfToken } from "../util/common"

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 20000 }
  }

  connect() {
    this.handlePageHide = this.handlePageHide.bind(this)
    this.startTracking()
  }

  disconnect() {
    this.stopTracking()
  }

  startTracking() {
    if (this.timer) return

    this.sendHeartbeat()
    this.timer = setInterval(() => this.sendHeartbeat(), this.intervalValue)
    window.addEventListener("pagehide", this.handlePageHide)
  }

  stopTracking() {
    if (!this.timer) return

    clearInterval(this.timer)
    this.timer = null
    window.removeEventListener("pagehide", this.handlePageHide)
  }

  sendHeartbeat() {
    fetchWithCsrf(this.urlValue, { method: "POST", keepalive: true }).catch((error) => console.error(error))
  }

  handlePageHide() {
    const formData = new FormData()
    formData.append("authenticity_token", getCsrfToken())
    navigator.sendBeacon(this.urlValue, formData)
  }
}
